import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root'
})
export class RecibirEncomiendaService {
    public oculto: String = 'oculto'

    constructor() {}

    hideModal() {
        this.oculto = 'oculto'
    }

    showModal() {
        this.oculto = ''
    }
}
